export class PipeModel {
  name: string;
  params: any;

  constructor(name: string, params?: any) {
    this.name = name;
    this.params = params;
  }
}
